import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var PendingAmtRes;
export const PendingAmtTodo = createAsyncThunk('PendingAmt', async (data) => {
    try {
        const res = await axios({
            method: "post",
            url: process.env.REACT_APP_API_URL + 'pending_amt',
            data: {
                "vcust_plant_code": localStorage.getItem("vcust_plant_code"),
            },
            headers: { "Content-Type": "application/json" }
        })
        return PendingAmtRes = res.data

    } catch (error) {
        return PendingAmtRes = error.response.data
    }
})

const PendingAmtSlice = createSlice({
    name: 'PendingAmt',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(PendingAmtTodo.fulfilled, (state, action) => {
            state.data = action.payload;
            // console.log('equipmentList', state.data.response)
        });
        builder.addCase(PendingAmtTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default PendingAmtSlice.reducer; 